type OnboardingStep = 'Company' | 'Info' | 'Contact' | 'ThankYou';

const ONBOARDING_STEPS: OnboardingStep[] = ['Company', 'Info', 'Contact', 'ThankYou'] as const;

const STEP_TO_INDEX = {
    Company: 0,
    Info: 1,
    Contact: 2,
    ThankYou: 3,
} as const satisfies Record<OnboardingStep, number>;

export type UseOnboardingReturn = {
    isOnboardingInProgress: ComputedRef<boolean>;
    currentStep: ComputedRef<OnboardingStep | undefined>;
    goNext: VoidFunction;
};

export const useOnboarding = (): UseOnboardingReturn => {
    const { data: session } = useAuthUtils();

    const getInitialStep = (): number => {
        if (session.value?.user?.company) {
            return STEP_TO_INDEX.Contact;
        }

        return STEP_TO_INDEX.Company;
    };

    const stepIndex = ref<number>(getInitialStep());

    const isOnboardingInProgress = computed(() => session.value?.user?.onboardingSessionFinishedAt === null);

    const currentStep = computed(() => ONBOARDING_STEPS.at(stepIndex.value));

    const goNext = (): void => {
        if (stepIndex.value === ONBOARDING_STEPS.length) return;

        stepIndex.value = stepIndex.value + 1;
    };

    return {
        isOnboardingInProgress,
        currentStep,
        goNext,
    };
};
